import { useParams } from 'react-router-dom';
import { sendTealiumEventByUploadStatus } from 'src/components/AddNewPeopleCSVModal/AddNewPeopleCSVModalAnalytics';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';
import { UploadStatus } from 'src/components/CSVUploadTracking/CSVUploadTracking.utils';

export interface UseEmployeesToAddAnalytics {
  sendAnalyticsByUploadStatus: (uploadStatus: UploadStatus) => void;
}

export const useEmployeesToAddAnalytics = (): UseEmployeesToAddAnalytics => {
  const { locId } = useParams<{ locId: string }>();

  const { sendAnalytics } = useSendAnalytics({
    eventcategory: 'self-service management tool_people',
    eventaction: locId ? 'loc_add_people_manually' : 'add people_manually',
    eventlabel: '',
  });

  return {
    sendAnalyticsByUploadStatus: (uploadStatus) =>
      sendTealiumEventByUploadStatus(sendAnalytics, uploadStatus),
  };
};
